import { getLocale } from '@/../vue-components/helpers/I18nPluginHelper.js';

// Locales using imperial system (US, UK, etc.). Default to metric for all others.
const IMPERIAL_LOCALES = new Set([`en`]);

export function usesMetric(locale) {
    if (!locale) locale = getLocale();
    locale = (locale || `en`).toLowerCase();
    return !IMPERIAL_LOCALES.has(locale);
}

function roundShort(n, digits = 0) {
    if (digits === 0) return Math.round(n);
    const pow = Math.pow(10, digits);
    return Math.round(n * pow) / pow;
}

/**
 * Format a distance using the appropriate unit for the current locale.
 * - Metric locales (fr, it, de, ca, ...) show meters/kilometers.
 * - English defaults to feet/miles.
 *
 * Options:
 * - style: 'short' | 'spaced' (default 'spaced')
 * - long: boolean (not used now, placeholder to expand for words 'meters')
 */
export function formatDistance(value, options = { style: `spaced` }) {
    if (value === undefined || value === null || isNaN(value)) return ``;
    const locale = getLocale();
    const short = options.style === `short`;

    const isMetric = usesMetric(locale);

    if (isMetric) {
        if (value >= 1000) {
            // kilometers
            const km = roundShort(value / 1000, 1);
            const display = (km % 1 === 0) ? `${Math.round(km)}` : `${km}`;
            return short ? `${display}km` : `${display} km`;
        } else {
            const m = Math.round(value);
            return short ? `${m}m` : `${m} m`;
        }
    }

    // Imperial
    const feet = Math.round(value * 3.28084);
    if (value >= 1609.34) {
        // miles
        const mi = roundShort(value / 1609.34, 1);
        const display = (mi % 1 === 0) ? `${Math.round(mi)}` : `${mi}`;
        return short ? `${display}mi` : `${display} mi`;
    }
    return short ? `${feet}ft` : `${feet} ft`;
}

export default {
    usesMetric,
    formatDistance,
};
